import React, { useEffect } from 'react';
import SignInForm from 'components/sign-in/SignInForm';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import { toJS } from 'mobx';
import MultiRoleTypesContent from 'components/sign-in/MultiRoleTypesContent';
import FormsSpinner from 'components/common/FormSpinner';
import SingleRoleTypeContent from 'components/sign-in/SingleRoleTypeContent';
import { createStyles } from '../../globalStyles';

const LoginPage = observer((): JSX.Element => {
  const classes = createStyles();

  // Mobx store
  const {
    roleTypeAndAgencyStore: { roleTypes, allAgencies, loading, getInitialDataForLoggedInUser, resetInitialData },
    loginSessionStore: { isLoggedIn },
  } = useRootStore();

  // Converted Data
  const convertedRoleTypes = roleTypes.map((type) => toJS(type)).slice();
  const convertedAgencies = allAgencies.map((agency) => toJS(agency)).slice();

  useEffect(() => {
    if (isLoggedIn && (convertedAgencies.length === 0 || convertedRoleTypes.length === 0)) {
      void getInitialDataForLoggedInUser();
    }
    return resetInitialData;
  }, [isLoggedIn]);

  const SignedInContent = (): JSX.Element => {
    if (convertedRoleTypes.length === 0) return <></>;
    if (convertedRoleTypes.length === 1) return <SingleRoleTypeContent roleType={convertedRoleTypes[0]} />;

    return <MultiRoleTypesContent />;
  };

  return (
    <div className={classes.formWrapper}>
      <h1 className={classes.title}>Sign In</h1>
      {loading ? <FormsSpinner display={loading} /> : <>{isLoggedIn ? SignedInContent() : <SignInForm />}</>}
    </div>
  );
});

export default LoginPage;
